// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__c3cBS","actions":"GroupTable_actions__1gS0p","deleteModalFooter":"GroupTable_deleteModalFooter__3MNtp"};